module.exports = __webpack_public_path__ + "img/GetItOnGooglePlay_Badge_Web_color_Russian.736099d9.png";